import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Toimitusrakenne',
  subtitle: 'Valitse, miten tilaukset toimitetaan (toimipaikkakohtaisesti).',
  form: {
    delivery_mode: {
      label: 'Toimitustila',
      placeholder: 'Valitse toimitustila',
      options: {
        [DeliveryMode.Internal]: 'Sisäinen (omat kuljettajat)',
        [DeliveryMode.External]: 'Ulkoinen (kolmas osapuoli)',
      },
    },
  },
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
    skip: 'Ohita',
  },
  toasts: {
    error: 'Jokin meni pieleen. Yritä uudelleen.',
  },
};
